import { Component, OnInit } from '@angular/core'
import { CardTypeEnum, GameResultEnum } from '@shared/enums'
import { PlayerService } from '../../../../@shared/services/player.service'
import { GameHistoryDto } from '@core/dtos'
import { GameResultIconsConst } from '@shared/constants'
import { CommonModule } from '@angular/common'
import { SvgIconComponent } from 'angular-svg-icon'
import { SmallCardComponent } from '@shared/components'

@Component({
  selector: 'app-game-history-mobile',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, SmallCardComponent],
  templateUrl: './game-history-mobile.component.html',
  styleUrl: './game-history-mobile.component.sass',
})
export class GameHistoryMobileComponent implements OnInit {
  cardType = CardTypeEnum
  gameResult = GameResultEnum

  gameHistoryData: GameHistoryDto[] = []

  constructor(private _playerService: PlayerService) {}

  ngOnInit(): void {
    this._playerService.gameHistory$.subscribe((i) => {
      this.gameHistoryData = i
    })
  }

  validResultSvg(result: string, ...columnResult: GameResultEnum[]): boolean {
    const _result = result as GameResultEnum

    return columnResult.includes(_result)
  }

  getResultSvg(result: string, ...columnResult: GameResultEnum[]): string {
    const _result = result as GameResultEnum

    if (!columnResult.includes(_result)) {
      return '—'
    }

    return GameResultIconsConst[_result]
  }
}
